<template>
  <v-dialog
    v-model="showDialog"
    @click:outside="cancelShareDialog"
    max-width="38vw"
    content-class="share-dialog"
  >
    <v-card class="pa-12">
      <v-card-title class="justify-center">
        <h3><nobr>Share this template with the following users</nobr></h3>
      </v-card-title>
      <v-combobox
        clearable
        v-model="selectedMembersToShare"
        class="pl-10 pr-10 mt-2"
        :items="usr"
        item-text="EmailAddress"
        item-value="Id"
        append-icon="fas fa-caret-down"
        chips
        placeholder="Select team member"
        multiple
        fixed
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 2">
            <span>{{ item.EmailAddress }}</span>
          </v-chip>
          <span v-if="index === 2" class="grey--text caption"
            >(+{{ selectedMembersToShare.length - 2 }} others)</span
          >
        </template>
      </v-combobox>
      <v-card-actions class="justify-center">
        <div class="mt-6">
          <v-btn
            id="cancel-btn-style"
            class="mr-4"
            text
            @click="cancelShareDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            id="share-btn-style"
            class="ml-4"
            :disabled="blockSaveButton || shareBtnloading"
            @click="confirmShareTemplateDialog"
          >
            <span v-if="!shareBtnloading">Save</span>
            <v-icon v-if="shareBtnloading" medium center
              >fas fa-spinner fa-spin</v-icon
            >
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      selectedMembersToShare: [],
      usr: [],
      addedMembers: [],
      removedMembers: [],
      blockSaveButton: true,
    };
  },
  computed: {
    ...mapGetters(["users"]),
    showDialog: {
      get() {
        return this.showShareTemplateDialog;
      },
      set(value) {
        this.$emit("update:showShareTemplateDialog", value);
      },
    },
  },
  props: [
    "showShareTemplateDialog",
    "templateId",
    "shareBtnloading",
    "sharedTemplateWith",
  ],
  methods: {
    cancelShareDialog() {
      this.showDialog = false;
    },
    confirmShareTemplateDialog() {
      this.retrieveAddedMembers();
      this.retrieveRemovedMembers();
      const data = {
        templateId: this.templateId,
        addedMembers: this.addedMembers.map((member) => member.EmailAddress),
        removedMembers: this.removedMembers.map(
          (member) => member.EmailAddress
        ),
      };
      this.$emit("confirmShareTemplateDialog", data);
    },
    retrieveAddedMembers() {
      this.selectedMembersToShare.forEach((user) => {
        if (
          !this.sharedTemplateWith.find(
            (member) => member.EmailAddress === user.EmailAddress
          )
        )
          this.addedMembers.push(user);
      });
    },
    retrieveRemovedMembers() {
      this.sharedTemplateWith.forEach((member) => {
        if (
          !this.selectedMembersToShare.find(
            (user) => user.EmailAddress === member.EmailAddress
          )
        )
          this.removedMembers.push(member);
      });
    },
  },
  watch: {
    showShareTemplateDialog() {
      if (this.showShareTemplateDialog) {
        this.addedMembers = [];
        this.removedMembers = [];
        this.blockSaveButton = true;
        this.usr = this.users;
        this.selectedMembersToShare = this.sharedTemplateWith;
        this.selectedMembersToShare.map((member) =>
          this.usr.splice(
            this.usr.findIndex(
              (user) => user.EmailAddress === member.EmailAddress
            ),
            1
          )
        );
        const usrTmp = this.usr;
        usrTmp.sort((current, next) =>
          current.EmailAddress.toLowerCase() < next.EmailAddress.toLowerCase()
            ? -1
            : current.EmailAddress.toLowerCase() >
              next.EmailAddress.toLowerCase()
            ? 1
            : 0
        );
        this.usr = this.selectedMembersToShare.concat(usrTmp);
      }
    },
    selectedMembersToShare() {
      if (
        this.selectedMembersToShare.length === this.sharedTemplateWith.length &&
        this.selectedMembersToShare.every((user) =>
          this.sharedTemplateWith.some(
            (member) => user.EmailAddress === member.EmailAddress
          )
        )
      )
        this.blockSaveButton = true;
      else this.blockSaveButton = false;
    },
  },
};
</script>

<style scoped>
#share-btn-style {
  background-color: #6db42c;
  color: #fff;
  font-family: "Montserrat";
  border-radius: 3px;
  width: 5vw;
}

.no-display {
  display: none;
}

#cancel-btn-style {
  font-family: "Montserrat";
  border-radius: 3px;
  width: 5vw;
}

.share-dialog h3 {
  font: 2.3vh "Montserrat";
  font-weight: bold;
}
</style>